import type { Note } from "../data/api-types";
import { mockToday as today } from "./today";

export const mockNote: Note = {
  id: "note_001",
  _self: "/notes/note_001",
  user_id: "user_001",
  customer_id: "cust_048",
  subject_type: null,
  subject_id: null,
  subject_label: null,
  note_text:
    "Procurement team prefers email for routine work, calls for urgent items.",
  note_title: "Comms preference",
  created_at: `${today}T10:00:00Z`,
  remind_me_at: null,
};

export const mockNotes: Note[] = [
  mockNote,
  {
    id: "note_002",
    _self: "/notes/note_002",
    user_id: "user_001",
    customer_id: "cust_012",
    subject_type: "opportunity",
    subject_id: "opp_001",
    subject_label: null,
    note_text: "Follow up next week if no response by Friday.",
    note_title: null,
    created_at: `${today}T11:00:00Z`,
    remind_me_at: null,
  },
  {
    id: "note_003",
    _self: "/notes/note_003",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Sarah confirmed they're planning a full rebrand for autumn 2026. Could be a major print job — prospectus, brochures, signage. Need to stay close.",
    note_title: "Rebrand opportunity",
    created_at: "2026-04-07T15:30:00Z",
    remind_me_at: null,
  },
  {
    id: "note_004",
    _self: "/notes/note_004",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: "task",
    subject_id: "ticket_001",
    subject_label: null,
    note_text:
      "Spoke to Sarah — she's happy with the last prospectus quality. Asked about heavier stock for the cover. Get sample sent.",
    note_title: null,
    created_at: "2026-04-05T09:45:00Z",
    remind_me_at: null,
  },
  {
    id: "note_005",
    _self: "/notes/note_005",
    user_id: "user_002",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Delivered leaflet artwork proofs. Sarah approved with minor QR code resize. Good turnaround.",
    note_title: "Artwork delivery",
    created_at: "2026-03-15T10:20:00Z",
    remind_me_at: null,
  },
  {
    id: "note_006",
    _self: "/notes/note_006",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Invoice query resolved — wrong cost centre on their side. Finance updated PO.",
    note_title: "Invoice #INV-2026-0847",
    created_at: "2026-03-21T11:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_007",
    _self: "/notes/note_007",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: "alert",
    subject_id: "alert_001",
    subject_label: null,
    note_text:
      "Order delay flagged — production backed up due to paper shortage. Spoke to ops, ETA revised to +3 days. Customer informed.",
    note_title: "Delay notification",
    created_at: "2026-03-10T14:15:00Z",
    remind_me_at: null,
  },
  {
    id: "note_008",
    _self: "/notes/note_008",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Annual account review completed. Presented 12-month spend summary and consolidation proposals. Sarah receptive to quarterly bundling.",
    note_title: "Account review notes",
    created_at: "2026-03-28T17:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_009",
    _self: "/notes/note_009",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Site visit to the Business School print room. Good to see their internal setup — helps us understand their quality expectations. They have an old Ricoh doing small runs internally.",
    note_title: "Site visit",
    created_at: "2026-03-07T13:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_010",
    _self: "/notes/note_010",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: "opportunity",
    subject_id: "opp_002",
    subject_label: null,
    note_text:
      "Retention signal triggered. Order frequency down 20% vs same period last year. Need to discuss with Sarah at next review.",
    note_title: null,
    created_at: "2026-02-28T08:30:00Z",
    remind_me_at: null,
  },
  {
    id: "note_011",
    _self: "/notes/note_011",
    user_id: "user_002",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "New contact: James Ward, Head of Events. Could be a route into conference material printing.",
    note_title: "New contact",
    created_at: "2026-02-20T16:45:00Z",
    remind_me_at: null,
  },
  {
    id: "note_012",
    _self: "/notes/note_012",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Paper stock discussion — they're interested in FSC-certified options for sustainability report. Get pricing from supplier.",
    note_title: "Sustainability",
    created_at: "2026-02-15T10:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_013",
    _self: "/notes/note_013",
    user_id: "user_001",
    customer_id: "cust_012",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Quarterly catch-up. They're expanding into digital marketing collateral. May reduce print volume but increase quality expectations.",
    note_title: "Q1 review",
    created_at: "2026-04-01T14:30:00Z",
    remind_me_at: null,
  },
  {
    id: "note_014",
    _self: "/notes/note_014",
    user_id: "user_001",
    customer_id: "cust_012",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "New brand guidelines received. Need to update all templates before next job.",
    note_title: "Brand update",
    created_at: "2026-03-18T09:15:00Z",
    remind_me_at: null,
  },
  {
    id: "note_015",
    _self: "/notes/note_015",
    user_id: "user_001",
    customer_id: "cust_012",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Pricing discussion — competitor quoted 15% lower on large format. Need to review our margin on this category.",
    note_title: "Competitive pressure",
    created_at: "2026-03-05T11:30:00Z",
    remind_me_at: null,
  },
  {
    id: "note_016",
    _self: "/notes/note_016",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Discussed possibility of managed print service for their campus. Would need to scope on-site equipment and staffing.",
    note_title: "Managed print enquiry",
    created_at: "2026-01-22T15:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_017",
    _self: "/notes/note_017",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Year-end review meeting. Total spend up 8% YoY. Biggest growth area: event materials. Smallest: stationery (going digital).",
    note_title: "Year-end review",
    created_at: "2026-01-10T10:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_018",
    _self: "/notes/note_018",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Sarah mentioned the university is shortlisting for a long-term print framework contract in Q3. We need to be on that list.",
    note_title: "Framework opportunity",
    created_at: "2026-04-08T16:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_019",
    _self: "/notes/note_019",
    user_id: "user_001",
    customer_id: "cust_012",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Delivery issue on last batch — 50 units short. Ops investigating, replacement batch dispatched same day.",
    note_title: "Delivery shortfall",
    created_at: "2026-02-12T08:45:00Z",
    remind_me_at: null,
  },
  {
    id: "note_020",
    _self: "/notes/note_020",
    user_id: "user_002",
    customer_id: "cust_012",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Met their new marketing manager, Rachel Torres. Very hands-on, wants to be involved in proofing. Good sign for engagement.",
    note_title: "New stakeholder",
    created_at: "2026-03-25T14:00:00Z",
    remind_me_at: null,
  },
  {
    id: "note_021",
    _self: "/notes/note_021",
    user_id: "user_001",
    customer_id: "cust_048",
    subject_type: null,
    subject_id: null,
    subject_label: null,
    note_text:
      "Budget approval for summer open day materials confirmed. Estimate to follow.",
    note_title: "Budget confirmed",
    created_at: "2026-04-02T12:00:00Z",
    remind_me_at: null,
  },
  // Anchor fixture for the job workspace redesign (docs/features/
  // job-workspace-redesign/) — a CIS note filed against job 738492.
  {
    id: "note_738492_1",
    _self: "/notes/note_738492_1",
    user_id: "user_001",
    customer_id: "c-capture-property",
    subject_type: "job",
    subject_id: "738492",
    subject_label: "Job 738492",
    note_text:
      "Confirmed with J Stops that the extra 5 tentcards can go on the next run instead — no need to hold this one up.",
    note_title: null,
    created_at: "2026-09-11T10:15:00Z",
    remind_me_at: null,
  },
];
